// extracted by mini-css-extract-plugin
export var closeButton = "points-widget-module--close-button--f125f";
export var pointsWidget = "points-widget-module--points-widget--a80fe";
export var visible = "points-widget-module--visible--1ab2c";